import { combineReducers } from 'redux';

import { reducer as ui } from 'app/common/domains/ui/ui-reducer';
import { reducer as user } from 'app/common/domains/user/user-reducer';
import {
  questionsReducer as questions,
  reviewsReducer as reviews,
  plagiarismCasesReducer as plagiarismCases,
} from 'app/queue/domains';

import { connectGqlApi } from './apis/connect-gql-api';
import { mentorGqlApi } from './apis/mentor-gql-api';
import { pensieveGqlApi } from './apis/pensieve-gql-api';
import { reviewsApi } from './apis/reviews';

export default combineReducers({
  ui,
  plagiarismCases,
  questions,
  reviews,
  user,
  [reviewsApi.reducerPath]: reviewsApi.reducer,
  [connectGqlApi.reducerPath]: connectGqlApi.reducer,
  [mentorGqlApi.reducerPath]: mentorGqlApi.reducer,
  [pensieveGqlApi.reducerPath]: pensieveGqlApi.reducer,
});
